var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, useState, useEffect, useContext, createContext, useCallback, } from 'react';
import styled from 'styled-components';
import { authClient } from 'lib/auth';
import { useMutation } from '@apollo/client';
import userDataSource from 'dataSources/userDataSource';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useHistory } from 'react-router-dom';
import CurrentUserQuery from './mutation.graphql';
var UserContext = createContext({
    user: undefined,
    userTenant: undefined,
    refreshUser: function () { },
    signOut: function () { },
    changeTenant: function () { },
    setUser: function () { },
    setUserTenant: function () { },
    hasRole: function () { return false; },
    tenant: undefined,
});
var UserConsumer = UserContext.Consumer;
var UserProvider = function (props) {
    var history = useHistory();
    var _a = __read(useState(), 2), user = _a[0], setUser = _a[1];
    var _b = __read(useState(), 2), userTenant = _b[0], setUserTenant = _b[1];
    var _c = __read(useState(), 2), tenant = _c[0], setTenant = _c[1];
    var _d = __read(useState(false), 2), isTokenLoaded = _d[0], setIsTokenLoaded = _d[1];
    var _e = __read(useMutation(CurrentUserQuery), 2), getUser = _e[0], userData = _e[1].data;
    var _f = authClient.useSession(), sessionData = _f.data, isPending = _f.isPending;
    useEffect(function () {
        var _a;
        if (isPending)
            return;
        if ((_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.token) {
            userDataSource.setToken(sessionData.session.token);
            setIsTokenLoaded(true);
        }
        else {
            userDataSource.setToken(null);
            setIsTokenLoaded(false);
        }
    }, [sessionData, isPending]);
    var signOut = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, authClient.signOut()];
                case 1:
                    _a.sent();
                    userDataSource.clearStorage();
                    if (window.Intercom) {
                        ;
                        window.Intercom('shutdown');
                    }
                    history.push('/sign-in');
                    return [2];
            }
        });
    }); }, [history]);
    var hasRole = function (role) {
        var tenantId = userDataSource.getTenantId();
        if (!user || !tenantId)
            return false;
        return user.tenantsObj[tenantId].role === role;
    };
    var changeTenant = useCallback(function (tenantId) {
        setTenant(tenantId);
        userDataSource.setTenantId(tenantId);
    }, []);
    useEffect(function () {
        var handleStorageChange = function (event) {
            if (event.key === 'Dango.accessToken' && event.newValue === null) {
                userDataSource.clearStorage();
                setIsTokenLoaded(false);
                setUser(undefined);
                history.push('/sign-in');
            }
        };
        window.addEventListener('storage', handleStorageChange);
        return function () { return window.removeEventListener('storage', handleStorageChange); };
    }, [history]);
    useEffect(function () {
        if (isTokenLoaded)
            getUser();
    }, [isTokenLoaded]);
    useEffect(function () {
        var _a, _b, _c;
        if (!isTokenLoaded || !(userData === null || userData === void 0 ? void 0 : userData.bootstrapUser))
            return;
        var loggedUser = userData.bootstrapUser;
        var bootstrappedUser = {
            id: loggedUser.id,
            email: loggedUser.email,
            tenantsObj: loggedUser.tenants.reduce(function (obj, t) {
                var _a;
                return Object.assign(obj, (_a = {}, _a[t.tenant.id] = t, _a));
            }, {}),
            tenants: loggedUser.tenants,
        };
        var existingTenantId = userDataSource.getTenantId();
        setUser(bootstrappedUser);
        var language = (_c = (_b = (_a = loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.preferences) === null || _a === void 0 ? void 0 : _a.language) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== null && _c !== void 0 ? _c : 'en';
        window.__localeId__ = language;
        localStorage.setItem('4Pets.__localeId__', language);
        if (existingTenantId)
            return;
        var defaultTenantId = bootstrappedUser.tenants[0].tenant.id;
        userDataSource.setTenantId(defaultTenantId);
        setTenant(defaultTenantId);
    }, [isTokenLoaded, userData, tenant]);
    useEffect(function () {
        var tenantId = userDataSource.getTenantId();
        setTenant(tenantId);
    }, []);
    useEffect(function () {
        if (!user || !tenant)
            return;
        var currentUserTenant = user.tenantsObj[tenant];
        if (!currentUserTenant) {
            history.push('/choose-account');
            setTenant(null);
            return;
        }
        if (window && window.Intercom) {
            var action = 'update';
            var attributes = {
                email: user.email,
                user_id: user.id,
                name: currentUserTenant.name,
            };
            window.Intercom(action, attributes);
        }
        setUserTenant(currentUserTenant);
    }, [tenant, user]);
    function refreshUser() {
        getUser();
    }
    var values = useMemo(function () { return ({
        user: user,
        userTenant: userTenant,
        signOut: signOut,
        setUser: setUser,
        setUserTenant: setUserTenant,
        tenant: tenant,
        changeTenant: changeTenant,
        hasRole: hasRole,
        refreshUser: refreshUser,
    }); }, [user, userTenant, tenant, changeTenant]);
    if (isPending) {
        return _jsx(Fallback, {}, void 0);
    }
    if (!sessionData) {
        history.push('/sign-in');
        return _jsx(Fallback, {}, void 0);
    }
    return isTokenLoaded && user ? (_jsx(UserContext.Provider, __assign({ value: values }, { children: props.children }), void 0)) : (_jsx(Fallback, {}, void 0));
};
var useUser = function () {
    var context = useContext(UserContext);
    if (context === undefined) {
        throw new Error('useUser must be used within an UserProvider');
    }
    return context;
};
export { UserProvider, UserConsumer, useUser };
var FallbackWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 64px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: calc(100vh - 64px);\n"], ["\n  position: absolute;\n  top: 64px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: calc(100vh - 64px);\n"])));
var Fallback = function () { return (_jsx(FallbackWrapper, { children: _jsx(CircularProgress, { size: 64 }, void 0) }, void 0)); };
var templateObject_1;
